import { TreeProps, TreeState, useTreeState } from 'react-stately';
import { RefObject, useState } from 'react';

export interface MenuState<T extends object> extends TreeState<T> {
    /**
     * Список открытых подменю, по ключу хранится ссылка на попап, в котором открыто соответствующее подменю
     */
    openedSubmenus: Record<string, RefObject<HTMLDivElement>>;

    /**
     * Фукнция, переключающая состояние подменю
     * @param key ключ подменю
     * @param ref ссылка на попап
     */
    toggleSubmenu(key: string, ref: RefObject<HTMLDivElement>): void;

    /**
     * Функция, открывающая подменю
     * @param key ключ подменю
     * @param ref cсылка на попап
     */
    openSubmenu(key: string, ref: RefObject<HTMLDivElement>): void;

    /**
     * Функция, закрывающая все подменю
     */
    closeSubmenus(): void;
}

export function useMenuState<T extends object>(props: TreeProps<T>): MenuState<T> {
    const treeState = useTreeState(props);
    const [openedSubmenus, setOpenedSubmenus] = useState<Record<string, RefObject<HTMLDivElement>>>({});

    return {
        ...treeState,
        openedSubmenus,
        toggleSubmenu(key: string, ref: RefObject<HTMLDivElement>) {
            const submenus: Record<string, RefObject<HTMLDivElement>> = {};
            if (!openedSubmenus[key]) {
                submenus[key] = ref;
            }

            setOpenedSubmenus(submenus);
        },
        openSubmenu(key: string, ref: RefObject<HTMLDivElement>) {
            setOpenedSubmenus({ [key]: ref });
        },
        closeSubmenus() {
            setOpenedSubmenus({});
        },
    };
}
